import { type Scope } from 'bunja';
import { createScopeFromContext } from 'bunja/react';
import { PropsWithChildren, createContext } from 'react';
import { FieldValues, FormProvider, UseFormReturn } from 'react-hook-form';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const RhfContext = createContext<UseFormReturn<any>>(null as unknown as UseFormReturn<any>);
export const RhfScope = createScopeFromContext(RhfContext);

export function typedRhfScope<T extends FieldValues>(): Scope<UseFormReturn<T>> {
  return RhfScope as Scope<UseFormReturn<T>>;
}

export interface RhfProviderProps<TFieldValues extends FieldValues> extends PropsWithChildren {
  methods: UseFormReturn<TFieldValues>;
}
export const RhfProvider = <TFieldValues extends FieldValues>(props: RhfProviderProps<TFieldValues>) => {
  const { children, methods } = props;
  return (
    <FormProvider {...methods}>
      <RhfContext.Provider value={methods}>{children}</RhfContext.Provider>
    </FormProvider>
  );
};
